import { render, staticRenderFns } from "./ClientsLevel.vue?vue&type=template&id=43511e5b"
import script from "./ClientsLevel.vue?vue&type=script&lang=js"
export * from "./ClientsLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports